module.exports = __webpack_public_path__ + "20241203142717/img/wx_tj.273f863d.png";